import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import { SHORT_STALE_TIME } from "@/lib/constants"

export function euetsOverviewOptions() {
	return queryOptions({
		queryKey: ["products", "euets", "overview"],
		queryFn: () => GET("/api/v1/euets/overview"),
		staleTime: SHORT_STALE_TIME,
	})
}

export function useEuetsOverview() {
	return useQuery(euetsOverviewOptions())
}
